import {Component, OnDestroy, OnInit} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {OrderService} from '../../shared/services/order.service';
import {User} from '../../shared/models/user';
import {SessionService} from '../../shared/services/session.service';
import {Subscription} from 'rxjs/internal/Subscription';
import {BreakpointObserver, Breakpoints} from "@angular/cdk/layout";

@Component({
  selector: 'mbnm-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.scss']
})
export class OrdersComponent implements OnInit, OnDestroy {

  displayedColumns;
  orders: MatTableDataSource<any>;
  private userChangedSubscription: Subscription;
  private mediaSub: Subscription;

  constructor(
    private orderService: OrderService,
    private media: BreakpointObserver
  ) { }

  ngOnInit() {
    this.userChangedSubscription = SessionService.currentUserChanged.subscribe(async (currentUser: User) => {
      const orders = await this.orderService.getOrders();
      for (const order of orders) {
        order.Reorder = true;
      }
      this.orders = new MatTableDataSource(orders);
    });

    this.mediaSub = this.media
      .observe([Breakpoints.XSmall])
      .subscribe( (val: any) => {
        if (val.matches) {
          this.displayedColumns = ['ConfirmationCode', 'OrderDate', 'Cart.grandTotal', 'Status', 'Reorder'];
        } else {
          this.displayedColumns = ['ConfirmationCode', 'OrderDate', 'Cart.shipping.fullname', 'Cart.grandTotal', 'Status', 'Reorder'];
        }
    });
  }

  ngOnDestroy() {
    if (this.userChangedSubscription && !this.userChangedSubscription.closed) {
      this.userChangedSubscription.unsubscribe();
    }

    if (this.mediaSub && !this.mediaSub.closed) {
      this.mediaSub.unsubscribe();
    }
  }
}
